module.exports = __webpack_public_path__ + "static/img/icon-number-5.73e4c516.svg";